import React, { memo } from 'react';
import { Layout } from '../../components/Layout';
import { Checklist } from '../../components/Checklist';
import { Button } from '../../components/ui/Button';
import { Card } from '../../components/ui/Card';
import { WINDOWS_CHECKLIST } from '../../utils/constants';
import { HardDrive, ShieldCheck, Lock, ArrowRight, AlertTriangle } from 'lucide-react';
import { Link } from 'react-router-dom';
export function Windows() {
  return <Layout data-id="element-2078">
      <div className="container mx-auto px-4 py-12" data-id="element-2079">
        <div className="mb-12" data-id="element-2080">
          <div className="inline-flex items-center px-3 py-1 rounded-full bg-cyan-500/10 text-cyan-400 text-xs font-medium mb-4 border border-cyan-500/20" data-id="element-2081">
            <HardDrive className="h-3 w-3 mr-2" data-id="element-2082" />
            Device Library
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-slate-100 mb-4" data-id="element-2083">
            Windows Security Protocol
          </h1>
          <p className="text-xl text-slate-400 max-w-3xl" data-id="element-2084">
            Pengamanan sistem operasi desktop paling populer dari ancaman
            ransomware dan malware.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-2085">
          <div className="lg:col-span-2 space-y-12" data-id="element-2086">
            <section data-id="element-2087">
              <h2 className="text-2xl font-bold text-slate-100 mb-6 flex items-center" data-id="element-2088">
                <ShieldCheck className="h-6 w-6 text-cyan-500 mr-3" data-id="element-2089" />
                Baseline Security
              </h2>
              <div className="space-y-4" data-id="element-2090">
                <Card className="p-5 border-l-4 border-l-cyan-500" data-id="element-2091">
                  <h3 className="font-bold text-slate-100 mb-1" data-id="element-2092">
                    BitLocker Encryption
                  </h3>
                  <p className="text-slate-400 text-sm" data-id="element-2093">
                    Wajib aktif untuk melindungi data jika laptop dicuri. Cek di
                    'Manage BitLocker'.
                  </p>
                </Card>
                <Card className="p-5 border-l-4 border-l-cyan-500" data-id="element-2094">
                  <h3 className="font-bold text-slate-100 mb-1" data-id="element-2095">
                    Standard User Account
                  </h3>
                  <p className="text-slate-400 text-sm" data-id="element-2096">
                    Jangan gunakan akun Administrator untuk aktivitas harian.
                    Buat akun Standard User terpisah.
                  </p>
                </Card>
                <Card className="p-5 border-l-4 border-l-cyan-500" data-id="element-2097">
                  <h3 className="font-bold text-slate-100 mb-1" data-id="element-2098">
                    Windows Defender
                  </h3>
                  <p className="text-slate-400 text-sm" data-id="element-2099">
                    Antivirus bawaan sudah sangat bagus. Pastikan 'Real-time
                    protection' aktif.
                  </p>
                </Card>
              </div>
            </section>

            <section data-id="element-2100">
              <h2 className="text-2xl font-bold text-slate-100 mb-6 flex items-center" data-id="element-2101">
                <Lock className="h-6 w-6 text-cyan-500 mr-3" data-id="element-2102" />
                Advanced Hardening
              </h2>
              <ul className="space-y-4 list-disc list-inside text-slate-300" data-id="element-2103">
                <li data-id="element-2104">
                  <strong className="text-slate-100" data-id="element-2105">
                    Controlled Folder Access:
                  </strong>{' '}
                  Fitur anti-ransomware bawaan Windows Defender. Aktifkan untuk
                  folder dokumen penting.
                </li>
                <li data-id="element-2106">
                  <strong className="text-slate-100" data-id="element-2107">Credential Guard:</strong>{' '}
                  (Windows Pro/Enterprise) Melindungi hash password di memori.
                </li>
                <li data-id="element-2108">
                  <strong className="text-slate-100" data-id="element-2109">DNS over HTTPS:</strong>{' '}
                  Aktifkan di browser atau sistem untuk mencegah pengintipan
                  ISP.
                </li>
              </ul>
            </section>

            <section className="border-t border-slate-800 pt-8" data-id="element-2110">
              <h2 className="text-xl font-bold text-slate-100 mb-4 text-red-400" data-id="element-2111">
                Common Mistakes
              </h2>
              <ul className="space-y-3 text-slate-400" data-id="element-2112">
                <li className="flex items-start" data-id="element-2113">
                  <AlertTriangle className="h-5 w-5 text-red-500/50 mr-3 flex-shrink-0 mt-0.5" data-id="element-2114" />
                  <span data-id="element-2115">
                    Mematikan UAC (User Account Control) karena merasa
                    terganggu.
                  </span>
                </li>
                <li className="flex items-start" data-id="element-2116">
                  <AlertTriangle className="h-5 w-5 text-red-500/50 mr-3 flex-shrink-0 mt-0.5" data-id="element-2117" />
                  <span data-id="element-2118">
                    Menggunakan software bajakan (Crack/Keygen) yang hampir
                    pasti berisi malware.
                  </span>
                </li>
              </ul>
            </section>
          </div>

          <div className="space-y-6" data-id="element-2119">
            <Checklist id="windows-checklist" title="Windows Checklist" items={WINDOWS_CHECKLIST} data-id="element-2120" />
            <Card className="p-6 bg-slate-900/50 border-slate-800" data-id="element-2121">
              <h3 className="font-bold text-slate-100 mb-4" data-id="element-2122">Next Steps</h3>
              <div className="space-y-3" data-id="element-2123">
                <Link to="/personal/identity" data-id="element-2124">
                  <Button variant="secondary" fullWidth className="justify-between group" data-id="element-2125">
                    Identity Security
                    <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" data-id="element-2126" />
                  </Button>
                </Link>
                <Link to="/tools" data-id="element-2127">
                  <Button variant="secondary" fullWidth className="justify-between group" data-id="element-2128">
                    Security Tools
                    <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" data-id="element-2129" />
                  </Button>
                </Link>
              </div>
            </Card>
          </div>
        </div>
      </div>
    </Layout>;
}